import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledThemeAlert = styled.div`
    padding: 16px 24px;
    border: 1px solid ${({ $isConnected }) => ($isConnected ? COLORS.$robinBlue : COLORS.$tartRed)};
    border-radius: 8px;
    background: ${({ $isConnected }) => ($isConnected ? COLORS.$robinTintsBlue : COLORS.$tartRedLite)};
    margin-bottom: 16px;
`;
